export default __webpack_public_path__ + "static/media/alexandergarden_thumb.886ae2e5.jpg";